module.exports = __webpack_public_path__ + "img/t4.d9f95096.png";